import { makeAutoObservable } from "mobx"
import Store from ".."
import LoyaltyStoreX from "../loyalty"
import {message} from "antd"
import {getProductAdds, getProductById, getProductVars} from "../../api/store"
import {createOrder} from "../../api/orders"
import { defaultStatuses, start } from "../../entities/status/consts"

export default class ProductStore {

  mainStore: Store
  loyaltyStore: LoyaltyStoreX

  product: any | null = null
  productTtls: any[] = []
  productDescs: any[] = []
  productTitle: string = ""
  productDesc: string = ""

  prePreVisible: boolean = false
  preVisible: boolean = false
  isCreateOrderVisible: boolean = false
  isCreateOrderLoading: boolean = false

  productAdds: any[] = []
  selectedAdds: any[] = []
  productSizes: any[] = []
  productMems: any[] = []
  productColors: any[] = []
  productImages: any[] = []

  selectedSize: any = null
  selectedMem: any = null
  selectedColor: any = null

  saleCalculated: boolean = false
  saleLoading: boolean = false
  totalSum: number = 0
  totalSale: number = 0
  availableBonuses: number = 0
  selectedSale: string = ""
  selectedPrice: string = ""

  promocode: string = ""
  promocodeActive: boolean = false

  activeTab: "feats" | "revs" | "about" | "delivery" = "about"

  constructor(main: Store, loyalty: LoyaltyStoreX) {
    makeAutoObservable(this)

    this.mainStore = main
    this.loyaltyStore = loyalty
  }

  public setAvailableBonuses = (val: any) => this.availableBonuses = val
  public setProduct = (val: any) => this.product = val
  public setProductTtls = (val: any) => this.productTtls = val
  public setProductDescs = (val: any) => this.productDescs = val
  public setProductTitle = (val: any) => this.productTitle = val
  public setProductDesc = (val: any) => this.productDesc = val

  public setPrePreVisible = (val: any) => this.prePreVisible = val
  public setPreVisible = (val: any) => this.preVisible = val
  public setIsCreateOrderVisible = (val: any) => this.isCreateOrderVisible = val
  public setIsCreateOrderLoading = (val: any) => this.isCreateOrderLoading = val

  public setProductAdds = (val: any) => this.productAdds = val
  public setSelectedAdds = (val: any) => this.selectedAdds = val
  public setProductSizes = (val: any) => this.productSizes = val
  public setProductMems = (val: any) => this.productMems = val

  public setProductColors = (val: any) => this.productColors = val
  public setSelectedSize = (val: any) => this.selectedSize = val
  public setSelectedMem = (val: any) => this.selectedMem = val
  public setSelectedColor = (val: any) => this.selectedColor = val
  public setProductImages = (val: any) => this.productImages = val

  public setSaleCalculated = (val: any) => this.saleCalculated = val
  public setSaleLoading = (val: any) => this.saleLoading = val
  public setTotalSum = (val: any) => this.totalSum = val
  public setTotalSale = (val: any) => this.totalSale = val
  public setSelectedSale = (val: any) => this.selectedSale = val
  public setSelectedPrice = (val: any) => this.selectedPrice = val
  public setPromocode = (val: any) => this.promocode = val
  public setPromocodeActive = (val: any) => this.promocodeActive = val
  public setActiveTab = (val: any) => this.activeTab = val

  public isHypeProductContext() {
    return this.loyaltyStore.selectedProductSource === "hype"
  }

  public getEffectiveDiscount() {
    if (this.isHypeProductContext()) {
      return this.getHypeProductsDiscount()
    }

    if (this.product?.is_subs === true) {
      return 50
    }

    return this.mainStore.totalSale
  }

  private getHypeProductsDiscount() {
    const statusDiscount = Number(this.loyaltyStore.myStatus?.hype_products_discount)
    if (Number.isFinite(statusDiscount)) {
      return statusDiscount
    }

    const statusCode = this.loyaltyStore.myStatus?.code ?? this.loyaltyStore.myStatus?.name
    const catalogStatus = [start, ...defaultStatuses].find(status => status.code === statusCode)

    return catalogStatus?.hype_products_discount ?? this.mainStore.totalSale
  }

  public getDiscountedFinalSum() {
    return (this.getFinalSum() / 100) * (100 - this.getEffectiveDiscount())
  }
    
  public async fetchProduct(pid: number) {
    const resProd = await getProductById(pid)

    this.setProductTtls(resProd.product.images_titles.split(";"))
    this.setProductDescs(resProd.product.images_descs.split(";"))
    this.setProductTitle(resProd.product.name)
    this.setProductDesc(resProd.product.about_mini)
    this.setProduct(resProd.product)

    if (resProd.product.about === "" && resProd.product.feats === "") {
      this.setActiveTab("revs")
    }

    const res = await getProductAdds(pid)
    const res2 = await getProductVars(pid)
    
    this.setProductAdds(res.adds)
    
    let vars: any[] = res2.vars
    let sizes: any[] = vars.filter(v => v.type === "size")
    let mems: any[] = vars.filter(v => v.type === "memory")
    let colors: any[] = vars.filter(v => v.type === "color")

    if (sizes.length > 0) {
      this.setSelectedSize(sizes[0])
    }
    if (mems.length > 0) {
      this.setSelectedMem(mems[0])
    }
    if (colors.length > 0) {
      this.setSelectedColor(colors[0])
    }

    this.setProductSizes(sizes)
    this.setProductMems(mems)
    this.setProductColors(colors)

    this.getAvailableBonuses(this.getFinalSum())
  }
  
  public async createOrder() {
    if (this.product === null) {
      return
    }
  
    // if (isNullOrUndefined(this.mainStore.subscribeData)) {
    //   message.warning("Для оформления заказа подключите подписку!")
    //   return
    // }
  
    if (parseInt(this.selectedSale) > parseInt(this.getAvailableBonuses(this.getFinalSum()).toFixed(0)) || parseInt(this.selectedSale) < 0) {
      message.error("Вы ввели недопустимое кол-во бонусов!")
      return
    }
  
    this.setIsCreateOrderLoading(prev => prev = true)
  
    const res = await createOrder({
      count: 1,
      type: "basic",
      tags: "",
      adds: this.getSelectedAdds(),
      vars: this.getSelectedVars(),
      photo: this.loyaltyStore.absPhoto,
      address: this.loyaltyStore.absBranch,
      barber_id: this.loyaltyStore.absBranchStaff,
      sum: this.getFinalSum() - parseInt(this.selectedSale),
      bonused: parseInt(this.selectedSale),
      status: 0,
      user_id: this.mainStore.userData.id,
      product_id: this.product.id
    })
  
    console.log(res)
  
    if (res.state === 0) {
      return message.warning(res.message)
    }
  
    setTimeout(() => {
      this.setIsCreateOrderVisible(false)
      this.setIsCreateOrderLoading(false)
  
      this.loyaltyStore.setIsProductVisible(false)
      this.loyaltyStore.setIsOrdersVisible(true)
    }, 2000)

    return true
  }

  public async calculatePrice() {
    if (this.product !== null) {
      if (this.promocode !== "") {
        if (this.promocode.toLowerCase() === this.product.promocode.toLowerCase()) {
          this.setPromocodeActive(true)
          message.success("Промокод успешно применен!")
        } else {
          this.setPromocode("")
          message.warning("Промокод не найден!")
          return
        }
      }

      this.setSaleLoading(true)

      setTimeout(() => {
        this.setTotalSum(this.product.price)
        this.setTotalSale(this.getEffectiveDiscount())
        
        let val = this.getAvailableBonuses(this.getFinalSum()).toFixed(0)
        this.setSelectedSale(`${val}`)
        setTimeout(() => {
          this.setSaleCalculated(true)
          this.setSaleLoading(false)
        }, 500)
      }, 500)
    }
  }
  
  public getSelectedVars() {
    let vars = ``

    if (this.selectedSize !== null) {
      vars += `Размер: ${this.selectedSize.value}. `
    }

    if (this.selectedMem !== null) {
      vars += `Память: ${this.selectedMem.value}. `
    }

    if (this.selectedColor !== null) {
      vars += `Цвет: ${this.selectedColor.value}. `
    }

    return vars
  }

  public getSelectedAdds() {
    let adds = ``

    this.selectedAdds.forEach(element => {
      const ex = this.productAdds.find(v => v.id === element)
      if (ex !== undefined) {
        if (adds !== "") {
          adds += ` ;; `
        }
        adds += `${ex.title} / ${ex.price}`
      }
    })

    return adds
  }

  public getFinalSum() {
    if (this.product.is_abs) {
      return parseInt(this.selectedPrice)
    }

    let adds = 0

    this.selectedAdds.forEach(element => {
      const ex = this.productAdds.find(v => v.id === element)
      if (ex !== undefined) {
        try {
          adds += parseInt(ex.price)
        } catch (e: any) {
          console.log(e)
        }
      }
    })

    return this.getStrainPrice() + adds
  }

  public getFinalSumAdds() {
    let adds = 0

    this.selectedAdds.forEach(element => {
      const ex = this.productAdds.find(v => v.id === element)
      if (ex !== undefined) {
        adds += ex.price
      }
    })

    return adds
  }

  public getStrainPrice() {
    return this.product.price + (this.selectedMem !== null ? this.selectedMem.price : 0) + (this.selectedColor !== null ? this.selectedColor.price : 0) + (this.selectedSize !== null ? 0 : 0)
  }

  public getAvailableBonuses = (price: number): number => {
    if (this.product === null) {
      return 0
    }
      
    if (this.product.is_abs) {
      price = parseInt(this.selectedPrice)
    }
  
    let sale = this.getEffectiveDiscount()
  
    // if (this.main!isNullOrUndefined(store.subscribeData) && this.mainStore.subscribeData !== undefined && this.promocodeActive) {
    //   sale = this.getTotalSale(this.mainStore.subscribeData.sub_name)
    // }
  
    // if (this.product.sale !== 0 && this.mainStore.subscribeData !== undefined) {
    //   sale = this.getTotalSale(this.mainStore.subscribeData.sub_name)
    // }
  
    const actualBon = this.loyaltyStore.bonuses
    const maxBon = (price / 100) * sale

    this.setAvailableBonuses(actualBon > maxBon ? maxBon : actualBon)
  
    return actualBon > maxBon ? maxBon : actualBon
  }

  public getTotalSale(sub: string) {
    if (sub === "sub2") {
      return 50
    }
    return 50
  }
  

}
